// assets
import { IconWallet, IconReceipt, IconCash, IconReportAnalytics } from '@tabler/icons';
import { createChildMenuItem, createChildGroupMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| OPERASIONAL MENU ITEMS ||============================== //

// Submenu items for operasional
const operasionalItems = [
  createMenuItem('input-pengeluaran', 'operasional.input.read', 'Input Pengeluaran', '/operasional/input-pengeluaran', IconReceipt, false),
  createMenuItem('saldo-operasional', 'operasional.saldo.read', 'Saldo Operasional', '/operasional/saldo', IconCash, false),
  createMenuItem('pengeluaran-operasional', 'operasional.pengeluaran.read', 'Pengeluaran Operasional', '/operasional/pengeluaran', IconReceipt, false),
  createMenuItem('laporan-operasional', 'operasional.laporan.read', 'Laporan Operasional', '/operasional/laporan', IconReportAnalytics, false)
];

const children = [
  {
    id: 'operasional',
    // Gunakan permission yang lebih general atau salah satu permission yang user punya
    // Jika user punya salah satu permission (saldo, pengeluaran, atau laporan), collapse akan muncul
    perm: 'operasional.pengeluaran.read', // Bisa diganti dengan permission lain yang user punya (atau operasional.input.read)
    title: 'Operasional',
    type: 'collapse',
    icon: IconWallet,
    children: createChildMenuItem(operasionalItems)
  }
];

const operasional = {
  id: 'operasional-group',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default operasional;

